import React, { useContext, useEffect, useState, Fragment } from 'react'
import { H2, P, Flex, Block, Button } from '../../components/basic'
import { Context } from '../../context'
import { setChoices } from '../../context/actions'
import { GAContext } from '../../context/googleAnalytics'
import { TopInfoBar } from './topInfoBar'
import { TopStepNavigation } from './topStepNavigation'
import { BottomStepNavigation } from './bottomStepNavigation'
import { Step } from './step'
import { ProductImages } from './productImages'
import { Review } from './review'
import { BorderColor, Blue_400, Blue } from '../../constants/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GaPageLoad } from '../../data/googleAnalytics'
import { faArrowLeft, faArrowRight } from '@fortawesome/fontawesome-free-solid'
import { LABELS, MESSAGES } from '../../constants'
import { useFeeAlertInjectionScript } from "../../hooks";

const ConstructNavigationArray = data => {
	let choicesArray = Object.values(data)
	choicesArray.sort((a,b) => {
		return a.key - b.key
	})
	return choicesArray
}

const HomePage = ({ appData }) => {
  	const [state, dispatch] = useContext(Context)
	const [gaState, gaDispatch] = useContext(GAContext)
	const [navigationData, setNavigationData] = useState(null)
	const [stepData, setStepData] = useState(null)

	const mobile = state.resize < 1025
	const startOverCheck = sessionStorage.getItem("startOverFromEdit")

	const restartOver = () => {
		if(appData.jpidata?.mode === "finishMyDesign" || appData.jpidata?.mode === "edit"){
			sessionStorage.setItem("startOverFromEdit", "true")
		}
		window.location.reload()
	}

	const startOverHandler = () => {
		sessionStorage.setItem("restartOver", true)
		dispatch({type: "SET_POPUP", payload: {
			title: <H2 align="center" margin="0 0 10px 0">{"ARE YOU SURE?"}</H2>,
			subTitle: <H2 align="center" margin="0 0 10px 0">{"THIS WILL RESET YOUR JACKET"}</H2>,
			info: <Fragment>
				{<Fragment>
					<P margin="10px 0 30px 0">{MESSAGES.JACKET_RESET_OPTIONS}</P>
					<Flex borderLeft={mobile && "1px solid lightgray"} width="auto">
						<Block width="auto" margin="0 10px 0 0">
							<Button
								onClick={() => { dispatch({ type: 'SET_POPUP', payload: null }); sessionStorage.removeItem("restartOver") }}
								fontSize="12px"
								margin="10px 0 0 0"
								hoverBackground={!mobile ? Blue : Blue_400}
								border="2px solid"
								borderColor={!mobile ? Blue : Blue_400}
								padding={mobile && "15px 20px"}
								background={!mobile ? Blue : Blue_400}
							>
								<Fragment>
									<FontAwesomeIcon icon={faArrowLeft} />
									{` ${LABELS.BUTTONS.GO_BACK}. ${LABELS.BUTTONS.KEEP_SELECTIONS}`}
								</Fragment>
							</Button>
						</Block>
						<Block width="auto" margin="0 10px 0 0">
							<Button
								onClick={() => restartOver()}
								fontSize="12px"
								margin="0 0 10px 0"
								hoverBackground={!mobile ? Blue : Blue_400}
								border="2px solid"
								borderColor={!mobile ? Blue : Blue_400}
								padding={mobile && "15px 20px"}
								background={!mobile ? Blue : Blue_400}
							>
								<Fragment>
									{`${LABELS.BUTTONS.PROCEED}. ${LABELS.BUTTONS.START_AGAIN} `}
									<FontAwesomeIcon icon={faArrowRight} />
								</Fragment>
							</Button>
						</Block>
					</Flex>
				</Fragment>}
			</Fragment>
		}})
    }

	useFeeAlertInjectionScript({
		customerId: window.jostens.customer.number,
		catalogOsr: appData.productdata?.catalogOsr,
	})

	useEffect(() => {
		const CalculateStepNumber = () => {
			if(state.step === "Review") {
				return state.stepamount - 1
			}
			for(let i = 0; i < appData?.jpidata?.steps?.length; i++) {
				if(appData?.jpidata?.steps[i]?.title === state.step) {
					return i
				}
			}
		}
		if(navigationData && (navigationData.length > 0)) {
			dispatch({type: 'SET_STEP_NUMBER', payload: CalculateStepNumber()})
		}
	}, [state.step, navigationData, dispatch, state.stepamount, appData.jpidata.steps])

	useEffect(() => {
		// applying below code to test JCOM-20295
		const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('debugError') && urlParams.get('debugError') === 'true') {
			throw new Error();
		}
	},[])

	useEffect(() => {
		const CreateChoiceData = data => {
			let newData = {}
			let key = 0
			for(let i = 0; i < data?.steps?.length; i++) {
				if(i === 0 && data?.mode === "edit" && !startOverCheck) {
					dispatch({type: "SET_STEP", payload: "Review"})
				}else if(i === 0){
					dispatch({type: "SET_STEP", payload: data?.steps[i]?.title})
				}
	
				for(let j = 0; j < data?.steps[i]?.substeps?.length; j++) {
					if((i === 0) && (j === 0)) {
						dispatch({type: "SET_SUBSTEP", payload: data?.steps[i]?.substeps[j]?.title})
					}
					let subStep = data.steps[i]?.substeps[j]
					let subStepProductOsr = {}
					let subStepProductDetail = {}
					if(subStep.products && (subStep.products?.length > 0)) {
						subStepProductOsr = subStep.products[0]
						subStepProductDetail = data.products[subStepProductOsr]
					} 
					else if(subStep.locations) {
						subStepProductOsr = subStep.locations[0]
						let locationName = data.locationFeatures[subStepProductOsr][0]
						subStepProductDetail = data.products[locationName]
					}

					if((data.mode === "edit" || data.mode === "finishMyDesign") && subStepProductDetail !== undefined && !startOverCheck){
						if(subStep.locations && subStep.locations.length > 0){
							subStepProductOsr = subStep.locations[0]
							let locationName = data.actualLocationProducts[subStepProductOsr]
							if (!locationName) {
								subStepProductDetail = {
									productId: null,
									imageUrl: subStepProductDetail.imageUrl,
									productPriceDescription: {
										//if step is required, set price equal to price of only available product.
										price: subStep.required
											? ((subStepProductDetail && subStepProductDetail.productPriceDescription && subStepProductDetail.productPriceDescription.price)
												? subStepProductDetail.productPriceDescription.price
												: 0)
											: 0
									}
								}
							} else if(locationName === "N") {
								subStepProductDetail = {
									"productId": "no",
									"productName": "No Thanks",
									"displayName": "No Thanks",
									"noImage": "noImage",
									"productPriceDescription": {
										"price": 0
									}
								}
							} else {
								subStepProductDetail = data.products[locationName]
							}
						}else if(subStep.products && (subStep.products.length > 0)) {
							subStepProductOsr = subStep.products[0]
							subStepProductDetail = data.products[subStepProductOsr]
						}
						
						newData[subStep.title] = {
							title: subStep.title,
							fields: {
							},
							required: subStep.required,
							completed: (data.mode === "edit") ? true : false,
							product: subStepProductDetail,
							step: data.steps[i].title,
							key: key
						}
						if(subStepProductDetail?.features && (subStepProductDetail.features?.length > 0)) {
							for(let k = 0; k < subStepProductDetail.features.length; k++) {
								
								// This Part Added For Case When Fields Missing Required Flag
								if (newData[subStep.title].fields) {
									const fieldsEntries = Object.entries(newData[subStep.title].fields).map(([key, field]) => {
										const currentFeature = subStepProductDetail.features.find(feature => feature.featureOsr === key)
										return currentFeature?.required
											? [key, { ...field, required: currentFeature.required }]
											: [key, field]
									})

									const modifiedFields = { ...newData[subStep.title].fields, ...Object.fromEntries(fieldsEntries) }

									newData[subStep.title].fields = modifiedFields
								}

								if(subStepProductDetail.features[k].options && (subStepProductDetail.features[k].options.length > 0)) {
									newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr] = {}
									newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr] = subStepProductDetail.configurations[k]
									newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr].chosenOsr = subStepProductDetail.configurations[k].optionOsr
									if((subStepProductDetail.features[k].displayType === "SINGLE_SELECT") || (subStepProductDetail.features[k].displayType === "STD_DROP")){
										for(let l = 0; l < subStepProductDetail.features[k].options.length; l++){
											if(subStepProductDetail.features[k].options[l].optionOsr === subStepProductDetail.configurations[k].optionOsr){
												newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr]["chosenOption"] = subStepProductDetail.features[k].options[l]
												newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr].chosenValue = subStepProductDetail.features[k].options[l]
											}
										}
									}else{
										newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr].chosenValue = subStepProductDetail.configurations[k].optionValue
									}
									
								}
							}
						}

					} else if(subStepProductDetail !== undefined) {
						newData[subStep.title] = {
							title: subStep.title,
							fields: {
							},
							required: subStep.required,
							completed: false,
							product: {
								productId: null,
								imageUrl: subStepProductDetail.imageUrl,
								productPriceDescription: {
									//if step is required, set price equal to price of only available product.
									price: subStep.required
										? ((subStepProductDetail && subStepProductDetail.productPriceDescription && subStepProductDetail.productPriceDescription.price)
											? subStepProductDetail.productPriceDescription.price
											: 0)
										: 0
								}
							},
							step: data.steps[i].title,
							key: key
						}
						
		
						// If substep is required, set product for substep to first available product in substep
						if(subStep.required && newData[subStep.title] && newData[subStep.title].product) {
							newData[subStep.title].product = subStepProductDetail
						}
						if(subStep.required && subStepProductDetail?.features && (subStepProductDetail.features?.length > 0)) {
							for(let k = 0; k < subStepProductDetail.features.length; k++) {
								if(subStepProductDetail.features[k].options && (subStepProductDetail.features[k].options.length > 0)) {
									newData[subStep.title].fields[subStepProductDetail.features[k].featureOsr] = ""
								}
							}
						}
						// If substep is required but has no fields, set it to auto completed
						if(subStep.required && (subStepProductDetail?.features && (subStepProductDetail.features.length < 1))) {
							newData[subStep.title].completed = true
						}
					}
					key += 1
				}
			}
			const navData = ConstructNavigationArray(newData)
			setNavigationData(navData)
			const designerTotalSteps = appData.jpidata.steps.length || 0
			dispatch({type: 'SET_STEP_AMOUNT', payload: designerTotalSteps})
			if(!gaState.pageLoad) {
				GaPageLoad(newData, { designerTotalSteps })
				gaDispatch({type: 'SET_PAGE_LOAD', payload: true})
			}
			return(newData)
		}
		setChoices(dispatch, CreateChoiceData(appData.jpidata))
	}, [dispatch, appData.jpidata.steps, appData.jpidata, gaDispatch, gaState.pageLoad, startOverCheck])

	useEffect(() => {
        for(let i = 0; i < appData.jpidata.steps.length; i++) {
			let step = appData.jpidata.steps[i]
			if(step !== undefined && step.title === state.step) {
				setStepData(appData.jpidata.steps[i])
			}
		}
	}, [state.step, appData.jpidata.steps])

	return (
		<Block padding="0 0 8rem 0">
			{navigationData && <TopInfoBar title={appData.jpidata.title} description={appData.jpidata.description} productData={appData.productdata} state={state} dispatch={dispatch}/>}
			{mobile
				?	
				<Block>
					{ navigationData && (state.step !== "Review") && 
						<ProductImages state={state} navigationData={navigationData} startOverHandler={startOverHandler} />
					}
					<Block>
						<Block>
							{state.step === "Review"
								? <Review dispatch={dispatch} state={state} />
								: <Step state={state} dispatch={dispatch} data={appData.jpidata} stepData={stepData} />
							}
							{navigationData && <BottomStepNavigation data={appData.jpidata} productData={appData.productdata} state={state} dispatch={dispatch} navigationData={navigationData} />}
						</Block>
					</Block>
				</Block>
				:	
				<Flex justify="space-between" align="flex-start" padding="0 2rem">
					{ navigationData && <ProductImages state={state} navigationData={navigationData} startOverHandler={startOverHandler}/> }
					<Block margin="0 0 0 30px" width={"calc(45% - 30px)"}>
						{navigationData && <TopStepNavigation state={state} dispatch={dispatch} data={appData.jpidata} />}
						<Block border="1px solid" borderColor={BorderColor}>
							{state.step === "Review"
								? <Review dispatch={dispatch} state={state} />
								: <Step state={state} dispatch={dispatch} data={appData.jpidata} stepData={stepData} />
							}
							{navigationData && <BottomStepNavigation state={state} dispatch={dispatch} data={appData.jpidata} productData={appData.productdata} navigationData={navigationData} />}
						</Block>
					</Block>
				</Flex>
			}
			
		</Block>
	)
}

export default HomePage
